function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "053---Follow-Podcast",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m53 27c-.0025742 12.5523216-8.9727001 23.3105823-21.32 25.57l-4.68 6.43-4.68-6.43c-13.52668441-2.4752324-22.78686598-15.0553883-21.13075748-28.7065887s13.65574478-23.65220102 27.38190418-22.82122849 24.4316732 12.20652789 24.4288533 25.95781719z",
  fill: "#e8edfc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m27 1c-.5 0-1 0-1.5.05 13.119528.78328884 23.5913822 11.2340934 24.4010678 24.3520187.8096857 13.1179254-8.2974539 24.7772159-21.2210678 27.1679813l-3.18 4.37 1.5 2.06 4.68-6.43c13.2155171-2.4337607 22.3991273-14.5371173 21.1846365-27.919871-1.2144907-13.3827537-12.4268963-23.635163-25.8646365-23.650129z",
  fill: "#cad9fc"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 31.01,
  cy: 19,
  fill: "#fff",
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m31 10c-.5026938.0026779-1.0043408.046154-1.5.13 4.3191604.7421807 7.4758281 4.4875373 7.4758281 8.87s-3.1566677 8.1278193-7.4758281 8.87c.4956592.083846.9973062.1273221 1.5.13 4.9705627-.0000001 8.9999998-4.0294373 8.9999998-9s-4.0294371-8.9999999-8.9999998-9z",
  fill: "#e8edfc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m45.43 36c-3.1037826 4.9833211-8.5591435 8.0125031-14.43 8.0125031s-11.3262174-3.029182-14.43-8.0125031c1.83-3.91 5.8-8 14.43-8s12.6 4.08 14.43 8z",
  fill: "#cad9fc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m31 28c-.52 0-1 0-1.5 0 7.6.45 11.21 4.27 12.93 8-2.8265243 4.5261709-7.6142765 7.4625108-12.93 7.93.49 0 1 .07 1.5.07 5.8683881.0026904 11.3232066-3.021464 14.43-8-1.83-3.92-5.8-8-14.43-8z",
  fill: "#a4c2f7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m22.32 52.57 4.68 6.43 1.5-2.06-3.18-4.37c-12.9236139-2.3907654-22.03075345-14.0500559-21.22106784-27.1679813.8096856-13.1179253 11.28153984-23.56872986 24.40106784-24.3520187-.5-.05-1-.05-1.5-.05-13.4377402.014966-24.65014579 10.2673753-25.86463652 23.650129-1.21449074 13.3827537 7.96911939 25.4861103 21.18463652 27.919871z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m1.27 18.82 1.9.61c-.73419831 2.4579884-1.12786536 5.0050479-1.17 7.57h-2c.0411042-2.7724393.46855233-5.5256091 1.27-8.18z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#428dff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m1.35 24c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1 1 .4477153 1 1-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m0 27c.0012793 12.8828496 9.10398521 23.9702301 21.74 26.48l4.45 6.11c.1880653.2597632.4893047.4135701.81.4135701s.6219347-.1538069.81-.4135701l4.45-6.11c13.6156042-2.7115328 22.955779-15.3065111 21.5968822-29.1228235-1.3588969-13.8163124-12.9739056-24.35025354-26.8568822-24.3571765-2.8438431.03433504-5.6672552.48581143-8.38 1.34-2.7053368.88474805-5.2510696 2.1981301-7.54 3.89-4.6248839 3.37858847-8.05944804 8.1365626-9.81 13.59-.08217123.2654546-.05018135.5531306.08829904.7940486.13848039.2409179.37096235.4133505.64170096.4759514.5147523.1374677 1.04689042-.1527894 1.21-.66 1.61422551-5.0456645 4.78170958-9.45214231 9.05-12.59 2.1274318-1.56398786 4.4903546-2.77920528 7-3.6 2.5067248-.78432898 5.1137106-1.20198561 7.74-1.24 12.9281654.00469645 23.7202641 9.8654146 24.8886184 22.7406789s-7.6724733 24.5175547-20.3886184 26.8493211c-.2521911.0445349-.4776852.1841265-.63.39l-3.87 5.32-3.87-5.3c-.1523148-.2058735-.3778089-.3454651-.63-.39-11.8811083-2.1741067-20.50885757-12.5316145-20.5-24.61 0-.5522847-.44771525-1-1-1s-1 .4477153-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m15.66 35.57c-.1604458.3200418-.137562.7014387.06 1 3.2861241 5.2775359 9.0630074 8.485716 15.28 8.485716s11.9938759-3.2081801 15.28-8.485716c.197562-.2985613.2204458-.6799582.06-1-1.9180867-4.145787-5.7074232-7.1207323-10.19-8 3.854252-2.3125771 5.6919678-6.9125558 4.4921427-11.2442635-1.1998251-4.3317076-5.1423378-7.33064029-9.6371427-7.33064029s-8.4373176 2.99893269-9.6371427 7.33064029c-1.1998251 4.3317077.6378907 8.9316864 4.4921427 11.2442635-4.4849237.8793992-8.2772775 3.8537943-10.2 8zm7.34-16.57c0-4.418278 3.581722-8 8-8s8 3.581722 8 8-3.581722 8-8 8-8-3.581722-8-8zm8 10c6.45 0 10.91 2.33 13.28 6.92-2.9721877 4.4228714-7.9512393 7.0757857-13.28 7.0757857s-10.3078123-2.6529143-13.28-7.0757857c2.37-4.59 6.83-6.92 13.28-6.92z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m11 21c-.5522847 0-1 .4477153-1 1v4h-4c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h4v4c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-4h4c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-4v-4c0-.5522847-.4477153-1-1-1z"
}))));

var SvgFollower = function SvgFollower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 54 60",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFollower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/follower.e6ec9ee9.svg";
export { ForwardRef as ReactComponent };